import { format, parse } from "date-fns"

const formatString = "yyyy-MM-dd"

export const serialize = (d: Date) => format(d, formatString)

export const deserialize = (s: string): Date | null => {
  if (!s.trim()) return null
  try {
    return parse(s, formatString, new Date())
  } catch (_e) {
    return null
  }
}
